import {Fragment} from "react"
import {ISODate} from "./date"
import {CalcFieldTypeMapEntry, AnyCalcTypeMap} from "./api/types"
import {
  apiToNotesFieldName,
  YesNoCalcTypeMap, CSVListCalcTypeMap, NonNegIntCalcTypeMap, DateCalcTypeMap,
  PoLCalcTypeMap, SoLCalcTypeMap, WtLCalcTypeMap,
} from "./api/generaltypemaps"

type Props = {
  name: string,
  calcField: CalcFieldTypeMapEntry<AnyCalcTypeMap>
}

const CODE_REGEX = /<code>(.*?)<\/code>|<example>(.*?)<\/example>|(dataName)/

export default function CalcFieldDoc({name, calcField}: Props) {
  const paragraphs = calcField.documentation.split("\n\n")
  return <tr>
    <td>&gt;@@{apiToNotesFieldName(name)}</td>
    <td>{
      calcField.typemap === CSVListCalcTypeMap ? "CSV-list"
      : calcField.typemap === YesNoCalcTypeMap ? "Yes/No"
      : calcField.typemap === NonNegIntCalcTypeMap ? "NonNegInt"
      : calcField.typemap === DateCalcTypeMap ? "Date"
      : calcField.typemap === PoLCalcTypeMap ? "PO-L"
      : calcField.typemap === SoLCalcTypeMap ? "SO-L"
      : calcField.typemap === WtLCalcTypeMap ? "WT-L"
      : "unknown (please report)"
      }
    </td>
    <td>{calcField.default instanceof Array ? "-"
    : calcField.default === true ? "Yes"
    : calcField.default === false ? "No"
    : calcField.default === null ? "-"
    : calcField.default instanceof ISODate ? calcField.default.toISOString()
    : calcField.default
    }</td>
    <td>{paragraphs.map((paragraph, index) => {
      const splits = paragraph.split(CODE_REGEX)
      return <p key={index}>{splits.map((s, index) =>
        s === undefined ? <Fragment key={index}></Fragment>
        : index % 4 === 0 ? <Fragment key={index}>{s}</Fragment>
        : index % 4 === 1 ? <code key={index}>{s}</code>
        : index % 4 === 2 ?
          <code key={index} className="example">
            &gt;@@{apiToNotesFieldName(name)}: {s}</code>
        : <em key={index}>{s}</em>
      )}</p>
    })}</td>
  </tr>
}


